import axios from "axios";
import React, { useEffect } from "react";

import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./app/store";
import "./fonts/ABBvoice_W_Rg.woff";
// pick a date util library
import DateFnsUtils from "@date-io/date-fns";
import { BrowserRouter, useLocation } from "react-router-dom";
import App from "./App";
import "./index.css";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Try to use the remote theme from storage.googleapis.com.
// If it fails (404, network, CORS, timeout), load the local file.
// Note however that the local file is static. Only the remote theme
// updates with the Customisation feature.
const remoteThemeUrl = `${process.env.REACT_APP_ASSETS_URL}/theme/theme.json`;
const localThemeUrl = `/assets/theme/${process.env.REACT_APP_THEME}`;

axios
    .get(remoteThemeUrl)
    .catch((err) => {
        console.warn("Remote theme failed, falling back to local theme:", err);
        return axios.get(localThemeUrl);
    })
    .then(function (response) {
        ReactDOM.render(
            <React.StrictMode>
                <Provider store={store}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <BrowserRouter>
                            <App themeData={response.data} />
                        </BrowserRouter>
                    </MuiPickersUtilsProvider>
                </Provider>
            </React.StrictMode>,
            document.getElementById("root")
        );
    })
    .catch((err) => {
        // Optional: if BOTH remote and local fail, at least log it
        console.error("Failed to load theme from both remote and local:", err);
        // You could still render with a default theme object here if you want.
    });


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
